export interface IHeatmapConfig {
  classification: string;
  displayText: string;
  opacity: 0.5;
  display: string;
  lowLabel?: string;
  highLabel?: string;
  showLegend?: boolean;
  isQuantificationLegend?: boolean | undefined;
}

export interface IHeatmap {
  slideName: string;
  classification: string;
  path: string;
  style: string;
  isActive: boolean;
  config: IHeatmapConfig;
}

export class Heatmap implements IHeatmap {
  slideName: string;
  classification: string;
  path: string;
  style: string;
  isActive: boolean;
  config: IHeatmapConfig;

  constructor(
    slideName: string,
    classification: string,
    path: string,
    style: string,
    isActive: boolean,
    config: IHeatmapConfig
  ) {
    this.slideName = slideName;
    this.classification = classification;
    this.path = path;
    this.style = style;
    this.isActive = isActive;
    this.config = config;
  }
}
